"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandingCardMode = void 0;
/**
 * {@docCategory HoverCard}
 */
var ExpandingCardMode;
(function (ExpandingCardMode) {
    /**
     * To have top compact card only
     */
    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
    /**
     * To have both top compact and bottom expanded card
     */
    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode || (exports.ExpandingCardMode = ExpandingCardMode = {}));
//# sourceMappingURL=ExpandingCard.types.js.map